import React, { useContext } from "react";
import ShopifyConnectionComponent from "../../../components/pages/settings/ShopifyConnectionComponent";
import { Box, Grid, ResponsiveContext } from "grommet";
import QuickbooksConnectionComponent from "../../../components/pages/settings/QuickbooksConnectionComponent";
import {signIn, useSession} from "next-auth/react";
import {useRouter} from "next/router";
import NetSuiteConnectionComponent from "../../../components/pages/settings/NetSuiteConnectionComponent";
import HubSpotConnectionComponent from "../../../components/pages/settings/HubSpotConnectionComponent";
import ApiConnectionComponent from '../../../components/pages/settings/ApiConnectionComponent';
import AppLayout from "../../../components/layouts/AppLayout";
import Footer from "../../../components/Footer";

const Connections = () => {
    const {data: session} = useSession();
    const {user} = session || {};
    const company = session?.company;
    const canAddCommerceIntegration = company?.can_add_commerce_integration !== false;
    const maxCommerceIntegrations = company?.max_commerce_integrations;
    const size = useContext(ResponsiveContext);
    const router = useRouter();
    const refreshSession = async () => {
        await signIn('credentials', { token: session?.accessToken, redirect: false });
        router.reload();
    };
    return (
        <AppLayout title="Connections" hasStickyDesktopPageHeader>
            <Box width={{ max: 'large' }} flex="grow">
                <Grid
                    columns={size === 'small'
                        ? ['auto']
                        : size === 'medium'
                            ? ['1/2', '1/2']
                            : ['1/3', '1/3', '1/3']}
                    align="stretch" gap="small" margin={{vertical: 'medium'}}>
                    <ApiConnectionComponent user={user} />
                    <ShopifyConnectionComponent
                        user={user}
                        canAddCommerceIntegration={canAddCommerceIntegration}
                        maxCommerceIntegrations={maxCommerceIntegrations}
                        onIntegrationChange={refreshSession} />
                    <HubSpotConnectionComponent
                        user={user}
                        canAddCommerceIntegration={canAddCommerceIntegration}
                        maxCommerceIntegrations={maxCommerceIntegrations}
                        onIntegrationChange={refreshSession} />
                    <QuickbooksConnectionComponent user={user} onLinked={refreshSession} />
                    <NetSuiteConnectionComponent />
                </Grid>
                <Footer />
            </Box>
        </AppLayout>
    );
};

export default Connections;
